import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { fetchCheckins } from '../../actions/checkins';
import viewHelper from '../../helpers/view';
import Spinner from '../shared/spinner';
import NoRecordFound from '../shared/noRecordFound';
import Filters from '../shared/filters';
import FilterService from '../../services/filterService';
import CONSTANTS from '../../constants';

let COMPONENT_TYPE = 'checkins';

class Checkins extends Component {

    constructor(props) {
        super(props);
        this.state = {
            filters: FilterService.getDefaultFilters(COMPONENT_TYPE)
        }
    }

    componentDidMount() {
        let params = FilterService.filtersToParams(this.state.filters);
        this.props.fetchCheckins(params);
    }

    isDenied(denied) {
        return denied === CONSTANTS.SETTINGS.CHECKINS.DENIED_CHECKIN;
    }

    renderCheckins() {
        let { checkins } = this.props;
        if(checkins.length > 0) {
            return _.map(checkins, (checkin) => {
                return (
                    <div className="media item" key={checkin.id}>
                        <div className="media-body">
                            <h4 className="media-heading">
                                {checkin.activity_name}
                            </h4>
                            <div className="column">
                                <span className="label-heading">Checkin Date:</span>
                                <span className="label-text">{viewHelper.getFormattedDateTime(checkin.checkin_at)}</span>
                            </div>

                            <div className="column">
                                <span className="label-heading">Checked In By:</span>
                                <span className="label-text">{checkin.entered_by}</span>
                            </div>

                            <div className="column">
                                <span className="label-heading">Denied:</span>
                                <span className="label-text">
                                    <span className={`${this.isDenied(checkin.denied) ? 'text-danger' : 'text-success'}`}>
                                        {this.isDenied(checkin.denied) ? 'Yes' : 'No'}
                                    </span>
                                </span>
                            </div>
                        </div>
                    </div>
                )
            });
        } else {
            return <NoRecordFound/>;
        }
    }

    setFilters(newFilters) {
        return this.setState({filters: newFilters}, () => {
            let params = FilterService.filtersToParams(this.state.filters);
            this.props.fetchCheckins(params);
        });
    }

    render () {
        const { checkins } = this.props;
        if(!checkins) {
            return (
                <div className="container content">
                    <Spinner />
                </div>
            );
        } else {
            return (
                <div className="col-xs-12 col-md-12 col-lg-12 no-padding">
                    <div className="row-eq-height border-top">
                        <div className="col-xs-12 col-md-3 col-lg-3 filters">
                            <Filters title='Filter Checkins' filters={this.state.filters} callbackToUpdateComponent={this.setFilters.bind(this)} />
                        </div>
                        <div className="col-xs-12 col-md-9 col-lg-10 no-padding border-bottom">
                            <ul className="detail-list">
                                {this.renderCheckins()}
                            </ul>
                        </div>
                    </div>
                </div>
            );
        }
    }
}
function mapStateToProps(state) {
    const { checkins } = state;
    return { checkins };
}

export default connect(mapStateToProps, { fetchCheckins })(Checkins);